__turbopack_context__.v({
  "closeIcon": "style-module-scss-module__sI-Nua__closeIcon",
  "dialogClose": "style-module-scss-module__sI-Nua__dialogClose",
  "dialogContent": "style-module-scss-module__sI-Nua__dialogContent",
  "fadeIn": "style-module-scss-module__sI-Nua__fadeIn",
  "fadeOut": "style-module-scss-module__sI-Nua__fadeOut",
  "hide": "style-module-scss-module__sI-Nua__hide",
  "overlay": "style-module-scss-module__sI-Nua__overlay",
  "overlayTransparent": "style-module-scss-module__sI-Nua__overlayTransparent",
  "show": "style-module-scss-module__sI-Nua__show",
  "visuallyHidden": "style-module-scss-module__sI-Nua__visuallyHidden",
});
